import { useEffect, useState } from "react"

import { api } from "~/utils/api"
import { useAuth0 } from "@auth0/auth0-react"

export default function useEnsureCompressedForecastsAreCorrect() {
  const utils = api.useUtils()
  const [hasChecked, setHasChecked] = useState(false)

  const { isAuthenticated } = useAuth0()

  const ensureForecastsAreCorrect = api.forecasts.ensureForecastCompressedIsCorrect.useMutation({
    onSuccess: (data) => {
      if (data.forecast) {
        console.debug("Has updated compressed forecasts in the backend ")
        utils.forecasts.getAllForecasts.invalidate()
      }
    },
  })

  useEffect(() => {
    if (isAuthenticated && hasChecked) ensureForecastsAreCorrect.mutate()
    setHasChecked(true)
  }, [isAuthenticated])
}
